import React, { useState, useEffect }  from 'react';
import { DataTable } from '@ampol/design-system';
import Status from '../../../../components/status/status';
import { currencyFormat } from '../../../../utilities/core-utilities';
import AmpolCashCardDetails from '../../components/ampol-cash-card-details/ampol-cash-card-details';
import './ampol-cash-card-details-modal.scss';
import { useDispatch } from 'react-redux';
import { getCashCardDetailsReset } from 'actions/cashActions';

/**
 * Ampol Cash Card Details Modal
 * @returns JSX Element
 */
const AmpolCashCardDetailsModal = ({ cardDetails }) => {
  const dispatch = useDispatch();

  const [cardDetailsTableData, setCardDetailsTableData] = useState([]);

  useEffect(() => {
    return () => dispatch(getCashCardDetailsReset());
  }, []);

  useEffect(() => {
    setCardDetailsTableData([{
      cardNumber: cardDetails?.cardNumber,
      cardValue: cardDetails?.cardValue,
      mediaType: cardDetails?.mediaType,
      status: cardDetails?.status
    }]);
  }, [cardDetails]);

  return <div className="ampol-cash-card-details-modal">
    <DataTable
      caption={'Ampol Cash Card Details'}
      columns={[
        {
          header: 'Card Number',
          accessorKey: 'cardNumber',
        },
        {
          header: 'Denomination',
          accessorFn: (x) => currencyFormat(x.cardValue)
        },
        {
          header: 'Type',
          accessorKey: 'mediaType',
        },
        {
          header: 'Status',
          accessorFn: (x) => <Status value={x.status} />,
        },
      ]}
      columnTemplate={'1fr 1fr 1fr 1fr'}
      data={cardDetailsTableData}
      tableVariant="list"
    />
    <AmpolCashCardDetails orderCardDetails={cardDetails} />
  </div>;
};

export default AmpolCashCardDetailsModal;
